import { Button, message, Modal, Select } from "antd"
import React, { useEffect, useState } from "react"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { useActions } from "../../../hooks/useActions"
import { IPlacementDataForUpdate } from "../store/types/placements"
import useAudience from "../hooks/useAudience"

interface AddCampaignToProjectProps {
  selectedCampaignIds: number[]
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  setPlacementsDataForUpdate: React.Dispatch<React.SetStateAction<IPlacementDataForUpdate[]>>
}

const SelectAudienceModal = React.memo(function SelectAudienceModal({
  selectedCampaignIds,
  isOpen,
  setIsOpen,
  setPlacementsDataForUpdate,
}: AddCampaignToProjectProps) {
  const [selectedAudience, setSelectedAudience] = useState<string | null>(null)

  const { audiences } = useTypedSelector((state) => state.audiences)
  const { fetchAudiences } = useActions()

  const { applyAudiencesToSelectedCampaigns } = useAudience({
    setPlacementsDataForUpdate,
    selectedCampaignIds,
    selectedAudience,
  })

  useEffect(() => {
    fetchAudiences()
  }, [])

  function applyToSelectedCampaigns() {
    if (selectedCampaignIds.length === 0) {
      message.error("Please select campaigns")
      return
    }

    const applied = applyAudiencesToSelectedCampaigns()
    if (!applied) {
      return
    }

    setIsOpen(false)
    message.success("Audiences applied to selected campaigns")
  }

  useEffect(() => {
    setSelectedAudience(null)
  }, [isOpen])

  return (
    <Modal
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={<Button onClick={applyToSelectedCampaigns}>Apply to selected</Button>}
      width={"40%"}
    >
      <Select
        options={audiences.map((audience) => ({
          label: audience.audienceResolved + " " + audience.audienceId,
          value: audience.audienceId,
        }))}
        value={selectedAudience}
        onChange={(value) => setSelectedAudience(value)}
        style={{ width: "85%" }}
        placeholder="Select Audience"
      />
    </Modal>
  )
})

export default SelectAudienceModal
